export const CHART_HANDLE_VARIANT_ENUM = {
  LEFT: 'left',
  RIGHT: 'right'
};

export default CHART_HANDLE_VARIANT_ENUM;
